(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5978],{

/***/ 68226:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-and-conditions",
      function () {
        return __webpack_require__(99902);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 99902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12918);
/* harmony import */ var _components_meta__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59409);
/* harmony import */ var _gql_queries_payment_methods__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48062);
/* harmony import */ var _screens_embeded_pdf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39145);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90644);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13135);













function TermsAndConditionsPage(props) {
    var metaInfo = props.metaInfo, url = props.url, paymentMethodName = props.paymentMethodName, isInvalidPaymentMethod = props.isInvalidPaymentMethod;
    var title = "T\xe9rminos y Condiciones";
    if (paymentMethodName) {
        title += " - ".concat(paymentMethodName);
    }
    if (isInvalidPaymentMethod) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_3__["default"], {
            statusCode: _utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .httpStatusCodes.NOT_FOUND */ .y3.NOT_FOUND
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_meta__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, metaInfo), {
                title: title,
                noRobots: true
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_screens_embeded_pdf__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                url: url
            })
        ]
    });
}
var getPaymentMethod = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(context) {
        var paymentMethodSlug, response, paymentMethods;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    paymentMethodSlug = context.query.paymentMethodSlug;
                    return [
                        4,
                        context.apolloClient.query({
                            query: _gql_queries_payment_methods__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z
                        })
                    ];
                case 1:
                    response = _state.sent();
                    paymentMethods = response.data.vendor.paymentMethods;
                    return [
                        2,
                        (0,lodash__WEBPACK_IMPORTED_MODULE_2__.find)(paymentMethods, {
                            slug: paymentMethodSlug
                        })
                    ];
            }
        });
    });
    return function getPaymentMethod(context) {
        return _ref.apply(this, arguments);
    };
}();
TermsAndConditionsPage.getInitialProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(context) {
        var ref, paymentMethodSlug, paymentMethod, hasSlug, isInvalidPaymentMethod, ref1, legalTermsUrl;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    paymentMethodSlug = context.query.paymentMethodSlug;
                    return [
                        4,
                        getPaymentMethod(context)
                    ];
                case 1:
                    paymentMethod = _state.sent();
                    hasSlug = paymentMethodSlug !== undefined;
                    isInvalidPaymentMethod = hasSlug && !paymentMethod;
                    if (isInvalidPaymentMethod && context.res) {
                        // eslint-disable-next-line no-param-reassign
                        context.res.statusCode = _utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .httpStatusCodes.NOT_FOUND */ .y3.NOT_FOUND;
                    }
                    legalTermsUrl = (ref1 = paymentMethod === null || paymentMethod === void 0 ? void 0 : (ref = paymentMethod.settings) === null || ref === void 0 ? void 0 : ref.legalTermsUrl) !== null && ref1 !== void 0 ? ref1 : context.vendor.legalTermsUrl;
                    if (!legalTermsUrl) {
                        (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .redirectTo */ .gB)("/", context);
                        return [
                            2
                        ];
                    }
                    if ((0,lodash__WEBPACK_IMPORTED_MODULE_2__.includes)(legalTermsUrl, "cloudinary")) {
                        return [
                            2,
                            {
                                url: legalTermsUrl,
                                isInvalidPaymentMethod: isInvalidPaymentMethod,
                                metaInfo: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .getMetaInfo */ .R7)(context),
                                paymentMethodName: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.name
                            }
                        ];
                    }
                    if (context.res) {
                        context.res.redirect(legalTermsUrl);
                    } else if (true) {
                        window.location.href = legalTermsUrl;
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function(context) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (TermsAndConditionsPage);


/***/ }),

/***/ 39145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
// Google Docs pdf embed workaround based on https://stackoverflow.com/a/61451002


var EmbededPdfScreen = function(props) {
    var url = props.url;
    var timeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var iframeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var source = "https://docs.google.com/gview?embedded=true&url=".concat(url);
    var setIframeSource = function() {
        if (iframeRef.current) {
            iframeRef.current.src = source;
        }
    };
    var onIframeLoad = function() {
        var ref, ref1;
        var contentLoaded = (ref = iframeRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : ref1.length;
        if (contentLoaded) {
            clearInterval(timeoutRef.current);
            return;
        }
        setIframeSource();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // 3 seconds is an arbitrary value to expect the iframe content to load
        timeoutRef.current = setInterval(setIframeSource, 1000 * 3);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            overflow: "hidden",
            height: "100vh"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
            title: "preview document",
            src: source,
            width: "100%",
            height: "100%",
            ref: iframeRef,
            onError: setIframeSource,
            onLoad: onIframeLoad
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EmbededPdfScreen);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(49484), __webpack_exec__(68226); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);